import React from 'react';

import { ExternalLinks } from '../components/ExternalLinks';

export const PrivacyPolicy: React.FC = () => {

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-3xl font-bold mb-8">"Privacy Policy"</h1>
        <div className="bg-white rounded-xl shadow-md p-8 prose prose-lg">
          <p className="text-gray-600 mb-8">"Effective: May 15, 2024"</p>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">"Introduction"</h2>
            <p>"We are committed to protecting your privacy. This policy explains how we handle your personal information."</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">"Data We Collect"</h2>
            <p className="mb-4">"We may collect the following types of information:"</p>
            <ul className="list-disc pl-6">
              {["Email addresses for account creation", "Technical logs from service usage", "Device information for security purposes"].map((item: string, index: number) => (
                <li key={index} className="mb-2">{item}</li>
              ))}
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">"Security Measures"</h2>
            <p>"We implement industry-standard security protocols including encryption and access controls to protect your data."</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">"Cookie Usage"</h2>
            <p>"We use session cookies to maintain your login state and improve service functionality."</p>
          </section>
        </div>

        <ExternalLinks type="privacy" />
      </div>
    </div>
  );
};